import { template, get, merge, omit, reject, find, sortBy, capitalize } from 'lodash';
import React, { Component, PropTypes } from 'react';
import formatPhone from '../../../lib/prettyPhone';
import { connect } from 'react-redux';
import Modal from '../../../common/components/Modal';
import ModalX from '../../../common/svgs/ModalX';
import Button from '../../../common/components/Button';
import DropDownMenu from '../../../common/components/c_DropDownMenu';
import CheckList from '../../../common/components/c_CheckList';
import SimpleFileInput from '../../../common/components/c_SourceSimpleFileInput';
import * as ui from '../../../redux/actionCreators/sync/ui';
import { getCompanyContacts, getCompanyJobs } from '../../../redux/actionCreators/async/companies';
import { getEmailTemplates, sendContactEmail } from '../../../redux/actionCreators/async/emails';
import { getUsersByRole } from '../../../redux/actionCreators/async/employees';
import {lookup} from '../../../redux/helpers/staticData';
import ItemAttachment from './ItemAttachment';
import EmailDialogModel from './model';
import { validateField, validate } from '../../../modelValidator';
import * as contactStore from '../../../redux/actionCreators/sync/contacts';
import * as contactApi from '../../../redux/actionCreators/async/contacts';

@connect(store => ({
  ui: store.ui,
  user: store.user,
  profile: store.profile,
  staticData: store.staticData,
  account: store.staticData.account,
  labels: store.labels
}))
export default class EmailDialog extends Component {
  static propTypes = {
    dispatch : PropTypes.func.isRequired,
    contact : PropTypes.object.isRequired,
    user : PropTypes.object.isRequired,
    profile : PropTypes.object.isRequired,
    onClose : PropTypes.func,
    staticData: PropTypes.array.isRequired,
    account: PropTypes.object.isRequired,
    labels: PropTypes.object.isRequired
  }

  constructor(props, context) {
    super(props, context);
    this.state = {
      ITManager: {
        firstName: '',
        lastName: ''
      },
      placementSpecialist: {
        firstName: '',
        lastName: ''
      },
      submitted: false,
      employees: [],
      contacts: [],
      templates: [],
      cc: [],
      attachments: [],
      form: {
        EmailTemplates: null,
        CCEmployees: [],
        CCCompany: [],
      }
    };
  }

  componentDidMount() {
    const {
      dispatch,
      user = {}
    } = this.props;
    const company = get(this.props, 'contact.company', {});
    const currentContact = get(this.props, 'contact', {});

    if (dispatch && company.id) {

       dispatch(getCompanyJobs(company.id, (err, data) => {

          const jobs = get(data, 'body.data.items', []);

          // Get first job request approved.
          const firstJobRequest = find(jobs, {primaryContactId: currentContact.profile.id, jobRequestStatus: 4});

          if(firstJobRequest === undefined) {
            return;
          }
          const placementSpecialist = find(this.props.staticData.placementSpecialists, { employeeId: firstJobRequest.placementSpecialistId});

          if(placementSpecialist) {
             this.setState({ placementSpecialist });
          }


      }));


      dispatch(getCompanyContacts(company.id, (err, res) => {
        if (err) {
          return console.error('Ooops, something related to getCompanyContacts went wrong');
        }

        const contacts = get(res, 'body.data.items', [])
          .filter(contact => contact.user.id !== currentContact.user.id);

        this.setState(merge({}, omit(this.state, ['contacts']), {contacts}));
      }));

      dispatch(getEmailTemplates())
        .then(templates => this.setState(merge({}, omit(this.state, ['templates']), {templates})));

      dispatch(getUsersByRole('IT Manager', (err, employeeList) => {

        if (err) {
          return console.error('Ooops, something related to getUsersByRole went wrong');
        }

         if(employeeList[0]) {
          this.setState({ITManager: employeeList[0]});
         }

      }));


      dispatch(getUsersByRole(undefined, (err, employeeList) => {
        if (err) {
          return console.error('Ooops, something related to getUsersByRole went wrong');
        }

        const employees = (employeeList || [])
          .filter(employee => employee.userId !== user.id);

        this.setState(merge({}, omit(this.state, ['employees']), {employees}));
      }));
    }
  }

  handleClose = (event) => {
    this.props.onClose && this.props.onClose(event);
  };

  handleSelectTemplate = (event, id) => {

    const newState = merge({}, this.state);
    newState.form.EmailTemplates = id;
    this.setState(newState);

  }

  handleSelectContact = (event, selected, id) => {
    const {
      cc,
      ...newState
    } = merge({}, this.state);
    const adding = ((selected || []).includes(id));
    const contact = newState.contacts.find(c => c.profile.userId === id);
    const employee = newState.employees.find(e => e.id === id);

    if(employee) {
        newState.form.CCEmployees = selected;
    }

    if(contact) {
        newState.form.CCCompany = selected;
    }

    const user = employee || get(contact, 'user');
    let CC;
    if (user) {
      if (adding && !cc.includes(user.email)) {
        CC = cc;
        CC.push(user.email);
      }
      else if (!adding) {
        CC = cc;
        const i = cc.findIndex(e => e === user.email);
        CC.splice(i, 1);
      }
    }

    if (CC) {
      this.setState({...newState, cc: CC});
    }
  }

  handleSendEmail = (event) => {
    const {
      cc = [],
      templates,
      attachments
    } = this.state;

    const {
      dispatch,
      contact: {
        profile: {
          id: contactId
        }
      }
    } = this.props;

    this.setState({submitted: true});

		const errors = validate(this.state.form, EmailDialogModel.getModel());
    if(errors.length) {
      this.setState({errors});
      return;
    }
    const {
      subject = ''
    } = find(templates, {id: this.state.form.EmailTemplates}) || {};

    const html = document.getElementById('email-dialog-editor').innerHTML;

    this.setState({sending: true});

    dispatch(sendContactEmail(contactId, cc, subject, html, attachments, (err) => {
      if (err) {
        return console.error('Ooops, something went wrong');
      }
      this.handleClose(event);
      this.props.dispatch(ui.showSnackBar('Email has been sent'));


        // refresh contact
        dispatch(contactApi.getContact(contactId, (err, data) => {
          if (err || !data) {
            return console.error(err || 'Fetch failed.');
          }
          dispatch(contactStore.updateContactInContactWorksheet(data));
        }));

    }));
  }


	validate(prop) {

		if(!this.state.submitted) {
      return;
    }

		const validation = validateField(this.state.form[prop], EmailDialogModel.getModel(prop));
		return validation[0];

	}

  renderEmployeeContacts() {
    const {
      employees = []
    } = this.state;

    const menuItems = sortBy(employees.map(user => ({id: user.id, name: `${capitalize(user.firstName)} ${capitalize(user.lastName)}`})), ['name']);

    if (menuItems.length) {
      return (
        <CheckList
          data-id='employees list'
          menuItems={menuItems}
          value={this.state.form.CCEmployees}
          onChange={this.handleSelectContact}
          floatingLabelText='CC Employees' />
      );
    }
  }

  renderCompanyContacts() {
    const {
      contacts = []
    } = this.state;

    const {
      contact : {
        company = {}
      } = {}
    } = this.props;

    const companyName = get(company, 'name', 'Company Contacts');
    const menuItems = sortBy(contacts.map(contact => ({id: contact.user.id, name: `${capitalize(contact.user.firstName)} ${capitalize(contact.user.lastName)}`})), ['name']);
    return (
        <CheckList
          data-id='contacts list'
          menuItems={menuItems}
          onChange={this.handleSelectContact}
          floatingLabelText={`CC ${companyName}`}
          errorText={this.validate('CCCompany')} />
      );

  }

  renderEmailTemplates() {
    const {
      templates = []
    } = this.state;

    return (
        <DropDownMenu
          data-id='templates dropdown'
          floatingLabelText='Email Templates'
          menuItems={templates}
          onChange={this.handleSelectTemplate}
          errorText={this.validate('EmailTemplates')}
        />
    );
  }

  maskCurrency(currency, precision = 2) {

    const currencyString = String(currency);
    const currencyNumber = Number(currencyString.replace(/[^0-9\.]+/g, ''));

    return currencyNumber.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: precision
    });

  }


  renderTemplate() {

    const { templates, ITManager, placementSpecialist } = this.state;
    const { contact } = this.props;
    const profile = JSON.parse(JSON.stringify(this.props.profile)); // Since we have to format the phone numbers we want a clone of the profile.

    const selected = find(templates, {id: this.state.form.EmailTemplates}) || {};

    const feeWaived = contact.company.placementFee === 0;
    const defaultPlacementFee = this.props.staticData.account.defaultSetupFee;
    const feeReduced = contact.company.placementFee > 0 && contact.company.placementFee < defaultPlacementFee;
    const hasSalesPartner = !!contact.company.salesPartner;
    const salesPartner = lookup(this.props.staticData, 'salesPartners', {id: contact.company.salesPartner}, 'commissionName');

    const jobReqDetails = {
      salesPartner,
      feeWaived,
      feeReduced,
      hasSalesPartner,
      waivedByClientAdvisor: false
    };

    ITManager.phoneNumber = formatPhone(ITManager.phoneNumber);
    ITManager.cellphoneNumber = formatPhone(ITManager.cellphoneNumber);
    profile.phoneNumber = formatPhone(profile.phoneNumber);
    profile.cellphoneNumber = formatPhone(profile.cellphoneNumber);

    const compiled = template(selected.html);

    const account = {
     ...this.props.account,
     logo: '',
     name: get(this.props.labels, 'Common.fullName', this.props.account.name),
     website: get(this.props.labels, 'Common.website', ''),
     mainColor: get(this.props.labels, 'Styles.mainColor'),
     domain: get(this.props.account, 'domain', '') ? `http://${get(this.props.account, 'domain')}` : '',
     url: get(this.props.account, 'domain', '') ? `http://${get(this.props.account, 'domain')}` : ''
    };

    const html = compiled({user: profile, contact, itm: ITManager, account, salesPartner, placementSpecialist, jobReqDetails});

    return (
      <div className='email-dialog-editor-container'>
        <div
          data-id='email editor'
          id='email-dialog-editor'
          className='email-dialog-editor'
          contentEditable='true'
          dangerouslySetInnerHTML={{__html: html}}
        />
      </div>
    );
  }

  onUploadStart = (err, file) => {

      const attachments = Object.assign(this.state.attachments);
      attachments.push(file);
      this.setState({attachments});

  }

 removeAttachment  = (name) => {

    return () => {

      const sAttachments = Object.assign(this.state.attachments);
      const attachments =  reject(sAttachments, {name});
      this.setState({attachments});

    };
 }


  onS3Load = err => {
    // updating UI optimistically so we only need to know if there was an error
    if(err && process.env.NODE_ENV !== 'production') {
      console.error(err);
    }
  }

  render() {
    const {
      company = {}
    } = this.props.contact;

    return (
      <Modal onClickOut={this.handleClose}>
        <div className='email-dialog'>
          <ModalX onClick={this.handleClose} />
          <h1 className={'modal-content-title'}>Email Message</h1>
          <div className='grid email-dialog-fields'>
            <div className='row'>
             <div className='col'>{ this.renderEmailTemplates() }</div>
             <div className='col'>{ this.renderEmployeeContacts() }</div>
             <div className='col'>{ this.renderCompanyContacts() }</div>
            </div>
          </div>
          <div className='email-dialog-editor-wrapper'>
            {
              this.renderTemplate()
            }
          <div className='attachments-container'>
            { this.state.attachments.map((attachment) => <ItemAttachment removeAttachment={this.removeAttachment} fileName={attachment.name} />) }
          </div>
          </div>
          <div className='email-dialog-actions'>
            <Button data-id='send email' label='send email' onClick={this.handleSendEmail} disabled={this.state.sending} />
            <Button data-id='cancel'  className='button-secondary' label='cancel' onClick={this.handleClose} />

              <SimpleFileInput
                data-id='uploader'
                className='file-uploader'
                noMessage
                pristineClass=''
                loadingClass=''
                successClass=''
                failureClass=''
                accept={['pdf', 'doc', 'docx', 'xls', 'xlsx', 'tiff', 'tig', 'txt', 'JPG', 'JPEG', 'jpg', 'jpeg', 'png']}
                remoteFolder={`employees/emails/${company.id}`}
                onLoadStart={this.onUploadStart}
                onS3Load={this.onS3Load}
                signingRoute='/api/s3/put-sign'
                maxSize={process.env.AWS_FILE_UPLOAD_SIZE}>

              <Button  data-id='attach file button' className='button-secondary' label='attach file'  />

            </SimpleFileInput>

          </div>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/Emails/index.js